import { render, staticRenderFns } from "./u-form.vue?vue&type=template&id=72fca944&scoped=true&"
import script from "./u-form.vue?vue&type=script&lang=js&"
export * from "./u-form.vue?vue&type=script&lang=js&"
import style0 from "./u-form.vue?vue&type=style&index=0&id=72fca944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fca944",
  null
  
)

export default component.exports